import React, { useState, useEffect } from "react";
import "./subsolos.css";
import { getLuzesStatusFlex8 } from "../../../API/basic/FeedBackLuzes";

import Sub01 from "./paginas/subsolo01";

const Subsolo = () => {
    const [luzesStatus, setLuzesStatus] = useState([]);
    const [subSoloAtual, setSubSoloAtual] = useState("sub01");

    useEffect(() => {
        const fetchData = async () => {
            const data = await getLuzesStatusFlex8();
            setLuzesStatus(data);
        };

        fetchData();
        const intervalId = setInterval(fetchData, 8000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="CampoSubsolo">
            <div className="menuSubSolo">
                <button
                    className={`botaoSubSolo ${subSoloAtual === "sub01" ? "selecionado" : ""}`}
                    onClick={() => setSubSoloAtual("sub01")}
                >
                    Sub 01
                </button>
            </div>
            {subSoloAtual === "sub01" && <Sub01 luzesStatus={luzesStatus} />}
        </div>
    );
};

export default Subsolo;
